
import {expandHeight} from "./Animation";
let $ = jQuery;

export class PollenCountWidget {

    protected closeIcon = $('.close-icon');
    protected pollenCounts = $('.pollen-counts');
    protected openIcon = $('.open-icon');
    protected animateTime = 300;
    protected todaysCount = $('.todays-count');

    public initialize() {
        this.openIcon.click(() => this.openPollenCount());
        this.closeIcon.click(() => this.closePollenCount());
    }

    public openPollenCount() {
        this.closeIcon.css('display','block');
        this.openIcon.css('display','none');
        this.pollenCounts.show();
        this.todaysCount.css({"background-color":"white"});
        expandHeight(this.pollenCounts,this.animateTime);
    }

    public closePollenCount() {
        this.openIcon.css('display','block');
        this.closeIcon.css('display','none');
        this.pollenCounts.css('display','none');
        $('.todays-count').css("background-color", "rgba(255, 255, 255, 0.6)");
        this.pollenCounts.stop().animate({height: '0' }, this.animateTime);
    }


}


// WEBPACK FOOTER //
// ./assets/ts/src/pollenCount/PollenCountWidget.ts